import {
    ApiUtils,
    _axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';

const api = {
    xiaoshou: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/baobiao/xiaoshou", params, successCallback, failCallback, exceptionCallback);
    },
    list: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/baobiao/list", params, successCallback, failCallback, exceptionCallback);
    },
}

export default api;